
import CostCenter from '../pages/soppbe/IdentifyMasterDataElements/CostCenter.vue';
import GFEBSAssignedReferenceNumber from '../pages/soppbe/IdentifyMasterDataElements/GFEBSAssignedReferenceNumber.vue';
import FiscalStationNumberFSN021001 from '../pages/soppbe/IdentifyMasterDataElements/FiscalStationNumberFSN021001.vue';
import TermnialLearningObjectiveEnd from '../pages/soppbe/IdentifyMasterDataElements/TerminalLearningObjectEnd.vue';
import COL from '../pages/soppbe/IdentifyMasterDataElements/COL.vue';

const secondaryRouter = [
    {
        path: '/ppbe/CostCenter',
        title: 'Cost Center',
        name: 'CostCenter',
        component: CostCenter,
    },
    {
        path: '/ppbe/GFEBSAssignedReferenceNumber',
        title: 'GFEBS Assigned Reference Number',
        name: 'GFEBSAssignedReferenceNumber',
        component: GFEBSAssignedReferenceNumber,
    },
    {
        path: '/ppbe/FiscalStationNumberFSN',
        title: 'Fiscal Station Number (FSN) (021001)',
        name: 'FiscalStationNumberFSN021001',
        component: FiscalStationNumberFSN021001,
    },
    { 
        title: 'Check on Learning',
        path: '/ppbe/COL',
        name: 'COL',
        component: COL,
    },
    { 
        path: '/ppbe/TermnialLearningObjectiveEnd',
        title: 'Termnial Learning Objective',
        name: 'TermnialLearningObjectiveEnd',
        component: TermnialLearningObjectiveEnd,
    }
]

export default secondaryRouter;